import { render, staticRenderFns } from "./RiderOrdersTableContainer.vue?vue&type=template&id=9d6748d6&"
import script from "./RiderOrdersTableContainer.vue?vue&type=script&lang=js&"
export * from "./RiderOrdersTableContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports